import { GeneralStrictEntityRelationDto } from "@/core/api/generated/v1";

import EntityLink, { EntityLinkProps } from "../../components/EntityLink/EntityLink";

interface Props extends Pick<EntityLinkProps, "linkProps" | "sx"> {
  value: GeneralStrictEntityRelationDto | null | undefined;
}

export default function GeneralStrictEntityRelationLink({ value, ...otherProps }: Props) {
  if (!value) {
    return null;
  }

  return (
    <EntityLink
      entityType={value.entityType}
      entityId={value.entityId}
      entity={
        value.vehicle ??
        value.vehicleDamage ??
        value.contract ??
        value.supplier ??
        value.accessory ??
        value.accessoryCheck ??
        value.visualInspection ??
        value.damageDetection ??
        value.damageDetectionAggregate ??
        value.damageCostEvaluation ??
        value.damageCostEvaluationAggregate ??
        value.repairOperation ??
        value.wash ??
        value.wheelOperation ??
        value.wash ??
        value.maintenance ??
        value.assetSubscriptionPlan ??
        value.assetSubscription ??
        value.tenantConnectionRequest ??
        value.tenantConnection ??
        value.tenantRequest
      }
      {...otherProps}
    />
  );
}
